import React from "react";
import axios from "axios";
import {API_URI} from "../../constant/Config";
import {t, DATE_FORMAT} from '../../constant/i18n';
import {SmileOutlined} from '@ant-design/icons';
import {Typography, Table, Form, Input, Radio, Button, Checkbox, DatePicker, Result, Alert, Col, Row} from "antd";
import moment from 'moment-timezone';
//moment.tz.setDefault("Europe/Paris");

const {Title, Text} = Typography;

class OrderTransactions extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            dataTrans: false,
            formDeclaration: <></>,
            formType: 'physique',
            idTransactionSelected: false,
            loadingBtnDeclaration: false,
        }
    }

    async componentDidMount() {

        await this.getTrans();
    }

    onFinish = async (values) => {
        this.setState({loadingBtnDeclaration: true});
        console.log('Success:', values);
        var token = localStorage.getItem('membre_token');
        var datePaiement = moment(values.datePaiement);

        const datePaiementTzParis = datePaiement.tz('Europe/Paris').format('YYYY-MM-DD HH:mm:ss');


        var valuePost = {
            ...values,
            idCmd: this.state.id,
            idTrans: this.state.idTransactionSelected,
            datePaiementTzParis: datePaiementTzParis
        }


        let dataCmd = await axios.post(API_URI + '/api_member/donateur-trans-add', valuePost, {
            headers: {
                'Authorization': token
            }
        })

        this.setState({
            formDeclaration: <Result
                icon={<SmileOutlined/>}
                title={t('orderTransactions.declarationSent')}
            />
        })

        return dataCmd.data;

    };


    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    getTrans = async () => {
        const liste = await axios.post(API_URI + '/api_member/payment-list-order', {id: this.state.id});
        await this.setState({dataTrans: liste});
    }


    loadForm = (idTransaction, formType) => {
        this.setState({
            formDeclaration: this.formDeclaration(idTransaction, formType)
        })

    }


    formDeclaration = (idTransaction, formType) => {
        if (formType == 'physique') {
            this.setState({})
            var typeForm = <div>
                <Form.Item
                    label={t('orderTransactions.lastName')}
                    name="nom"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label={t('orderTransactions.firstName')}
                    name="prenom"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
            </div>;
        } else {
            var typeForm = <div>
                <Form.Item
                    label={t('orderTransactions.denomination')}
                    name="denomination"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label={t('orderTransactions.legalForm')}
                    name="forme_juridique"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label={t('orderTransactions.siren')}
                    name="siren"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
            </div>;

        }
        this.setState({idTransactionSelected: idTransaction})
        return (
            <Form
                name="basic"
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 10,
                }}
                layout="horizontal"
            >
                <Row>
                    <Col span={10} offset={4}>
                        <Alert message={t('orderTransactions.multiDonators')} type="info"/>
                    </Col>
                </Row>
                <br />
                <Form.Item label={t('orderTransactions.youAre')} name="size">
                    <Radio.Group defaultValue="particulier">
                        <Radio.Button value="particulier" onClick={() => this.loadForm(idTransaction, 'physique')}>{t('orderTransactions.individual')}</Radio.Button>
                        <Radio.Button value="entreprise" onClick={() => this.loadForm(idTransaction, 'societe')}>{t('orderTransactions.company')}</Radio.Button>
                    </Radio.Group>
                </Form.Item>

                {typeForm}

                <Form.Item
                    name="email"
                    label={t('common.email')}
                    rules={[
                        {
                            type: 'email',
                            required: true,
                            message: t('orderTransactions.emailInvalid'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label={t('orderTransactions.streetNumber')}
                    name="numero"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label={t('orderTransactions.streetName')}
                    name="rue"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label={t('orderTransactions.postalCode')}
                    name="cp"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label={t('orderTransactions.city')}
                    name="commune"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label={t('orderTransactions.paymentDate')}
                    name="datePaiement"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.fillInfo'),
                        },
                    ]}>
                    <DatePicker format={DATE_FORMAT}/>
                </Form.Item>

                <Form.Item
                    wrapperCol={{offset: 4, span: 10}}
                    name="confirmation"
                    valuePropName="checked"
                    rules={[
                        {
                            required: true,
                            message: t('orderTransactions.confirmCheck'),
                        },
                    ]}
                >
                    <Checkbox>{t('orderTransactions.declarationStatement')}</Checkbox>
                </Form.Item>


                <Form.Item wrapperCol={{offset: 4, span: 10}}>
                    <Button type="primary" htmlType="submit" loading={this.state.loadingBtnDeclaration}>{t('orderTransactions.validateDeclaration')}</Button>
                </Form.Item>
            </Form>
        );
    }

    render() {
        const columns = [
            {
                title: t('orderTransactions.id'),
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: t('orderTransactions.amount'),
                dataIndex: 'montant',
                key: 'montant',
            },
            {
                title: t('orderTransactions.date'),
                dataIndex: 'date',
                key: 'date',
            },
            {
                title: t('orderTransactions.state'),
                dataIndex: 'etat',
                key: 'etat',
            },
            {
                title: '',
                dataIndex: 'action',
                key: 'action',
            },
        ];

        if (this.state.dataTrans != false) {
            const dataTrans = this.state.dataTrans.data.data;
            var dataFinal = [];
            var listeDates = Object.keys(dataTrans).map(function (key) {
                var action = '';

                dataFinal.push({
                    key: key,
                    id: dataTrans[key]['id'],
                    montant: dataTrans[key]['amount'],
                    date: dataTrans[key]['date'],
                    etat: dataTrans[key]['libEtat'],
                    action: action
                })
            });
            var data = dataFinal
        } else {
            var data = []
        }

        return (
            <div>
                {this.state.formDeclaration}
                <Table columns={columns} dataSource={data}/>
            </div>
        );
    }
}

export default OrderTransactions;